import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { url } from '../../Constant';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { apiPost } from '../../Utils/apiServices';
import { useNavigate } from 'react-router-dom';


const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    cutomerName: '',
    customerAddress: '',
    customerNumber: '',
    package_id: '',
   
  });
  
  const [errors, setErrors] = useState({
    cutomerName: '',
    customerAddress: '',
    customerNumber: '',
    package_id: '',
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [TRpackages, setTRpackages] = useState([]);
  const [TRpackagesLoading, setTRpackagesLoading] = useState(false);
  const [selectedpackageDetails, setSelectedpackageDetails] = useState({});


  useEffect(() => {

    if (!TRpackages.length) {
      setTRpackagesLoading(true);
      apiPost("auth/pacakge-info", (res) => {
        if (res.status === true) {
          setTRpackages(res.data);
        }
        setTRpackagesLoading(false);
      }, (err) => {
        setTRpackagesLoading(false);
      })
    }
  }, [TRpackages])


  

  const validateEmail = (email) => {
    const mailformat = /^[A-Za-z][\w$.]+@[\w]+\.\w+$/;
    return mailformat.test(email);
  };

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
    return passwordRegex.test(password) && password.length >= 14;
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Customer Name validation
    if (!formData.cutomerName.trim()) {
      newErrors.cutomerName = 'Customer name is required';
      isValid = false;
    } else {
      newErrors.cutomerName = '';
    }

    // Customer Address validation
    if (!formData.customerAddress.trim()) {
      newErrors.customerAddress = 'Customer address is required';
      isValid = false;
    } else {
      newErrors.customerAddress = '';
    }

    // Customer Contact Number validation
    if (!formData.customerNumber) {
      newErrors.customerNumber = 'Contact number is required';
      isValid = false;
    } else if (formData.customerNumber.length !== 11) {
      newErrors.customerNumber = 'Contact number must be 11 digits';
      isValid = false;
    } else {
      newErrors.customerNumber = '';
    }

    // Customer Packages validation
    if (!selectedpackageDetails?.package_id) {
      newErrors.package_id = 'Please select a package';
      isValid = false;
    } else {
      newErrors.package_id = '';
    }

    // Email validation
    // if (!formData.email) {
    //   newErrors.email = 'Email is required';
    //   isValid = false;
    // } else if (!validateEmail(formData.email)) {
    //   newErrors.email = 'Invalid email format';
    //   isValid = false;
    // } else {
    //   newErrors.email = '';
    // }

    // Mobile validation
    // if (!formData.mobile) {
    //   newErrors.mobile = 'Mobile number is required';
    //   isValid = false;
    // } else if (formData.mobile.length !== 11) {
    //   newErrors.mobile = 'Mobile number must be 11 digits';
    //   isValid = false;
    // } else {
    //   newErrors.mobile = '';
    // }

    // Password validation
    // if (!formData.password) {
    //   newErrors.password = 'Password is required';
    //   isValid = false;
    // } else if (!validatePassword(formData.password)) {
    //   newErrors.password = 'Password must be at least 14 characters long and include uppercase, lowercase, numbers, and special characters';
    //   isValid = false;
    // } else {
    //   newErrors.password = '';
    // }

    // Confirm password validation
    // if (formData.password !== formData.confirmPassword) {
    //   newErrors.confirmPassword = 'Passwords do not match';
    //   isValid = false;
    // } else {
    //   newErrors.confirmPassword = '';
    // }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    const payload = {
      ...formData,
      package_id: selectedpackageDetails?.package_id,
    };

    
    if (validateForm()) {
      setIsSubmitting(true);
      try {
        const response = await apiPost(`auth/sign-up`,(res) => {
          
          if (res?.code === 200) {
            toast.success(res?.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            setIsSubmitting(false);
            setTimeout(() => {
              navigate('/');
            }, 2000);
          }

        },
        (err) => {
          toast.error(err.response?.data?.message || 'Signup failed. Please try again.', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          
        }, payload);
          // Redirect to login page or dashboard
          // history.push('/login');
        }
        catch (error) {
        toast.error(error.response?.data?.message || 'Signup failed. Please try again.', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className="dashboardWrp">
      <div className="uk-container">
        <div className="dashboardTop">
          <div className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/">
                  <img src="/assets/images/zong/chevron--left.svg" alt="Back" />
                  <span>Back to Login</span>
                </Link>
                <h3>Sign Up</h3>
                <p>Please fill in the form below to sign up.</p>
              </div>
            </div>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="uk-grid" uk-grid>
              <div className="uk-width-1-1@m">
                <div className="formCreateMain">
                  <div className="uk-grid uk-grid-small">
                    <div className="uk-width-1-1@m">
                      <legend className="uk-legend">Personal Information</legend>
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>Customer Name *</label>
                      <input
                        className="uk-input"
                        type="text"
                        name="cutomerName"
                        placeholder="Enter customer name"
                        value={formData.cutomerName}
                        onChange={handleChange}
                      />
                      {errors.cutomerName && <div className="formErrors">{errors.cutomerName}</div>}
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>Customer Address *</label>
                      <input
                        className="uk-input"
                        type="text"
                        name="customerAddress"
                        placeholder="Enter customer address"
                        value={formData.customerAddress}
                        onChange={handleChange}
                      />
                      {errors.customerAddress && <div className="formErrors">{errors.customerAddress}</div>}
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>Customer Contact Number *</label>
                      <input
                        className="uk-input"
                        type="tel"
                        name="customerNumber"
                        placeholder="e.g., 03001234567"
                        value={formData.customerNumber}
                        onChange={handleChange}
                      />
                      {errors.customerNumber && <div className="formErrors">{errors.customerNumber}</div>}
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>Customer Package *</label>
                      <select
                        className="uk-select"
                        name="customer_packages"
                        onChange={(e) => {
                          TRpackages.find((Trpakage) => {
                            if (Trpakage.package_id == e.target.value) {
                              setSelectedpackageDetails(Trpakage);
                            }
                            
                          })
                        }}
                        disabled={TRpackagesLoading}
                      >
                        <option value="">  {TRpackagesLoading ? 'Loading...' : 'Select a package...'}</option>
                        {TRpackages.map((TRpackage) => (
                          <option  key={TRpackage.package_id} value={TRpackage.package_id}>
                            {TRpackage?.pacakgeName}
                          </option>
                        ))}
                      </select>
                      
                      {errors.customer_packages && <div className="formErrors">{errors.customer_packages}</div>}
                    {selectedpackageDetails?.package_id && (
                      <div className=" uk-margin-top">
                        <div className="uk-card uk-card-default uk-card-small">
                          <div className="uk-card-header">
                            <h4 className=" uk-margin-remove"> Package Summary</h4>
                            <div className="uk-text-meta uk-margin-small-top">{selectedpackageDetails?.pacakgeName || '-'}</div>
                          </div>
                          <div className="uk-card-body">
                            <div className="uk-grid uk-grid-small" uk-grid="true">
                              <div className="uk-width-1-2@m">
                                <div className="uk-text-muted">Price</div>
                                <div className="uk-text-bold">
                                  {selectedpackageDetails?.bundlePrice != null ? `PKR ${Number(selectedpackageDetails.bundlePrice).toLocaleString()}` : '-'}
                                </div>
                              </div>
                              <div className="uk-width-1-2@m">
                                <div className="uk-text-muted">Minutes</div>
                                <div className="uk-text-bold">
                                  {selectedpackageDetails?.allNetMinutes != null ? `${Number(selectedpackageDetails.allNetMinutes).toLocaleString()} mins` : '-'}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    </div>


                    {/* <div className="uk-width-1-2@m uk-margin-top">
                      <label>Email Address *</label>
                      <input
                        className="uk-input"
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <div className="formErrors">{errors.email}</div>}
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>Mobile Number *</label>
                      <input
                        className="uk-input"
                        type="tel"
                        name="mobile"
                        placeholder="e.g., 03001234567"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                      {errors.mobile && <div className="formErrors">{errors.mobile}</div>}
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>CNIC (Optional)</label>
                      <input
                        className="uk-input"
                        type="text"
                        name="nic"
                        placeholder="e.g., 3520112345678"
                        value={formData.nic}
                        onChange={handleChange}
                      />
                      {errors.nic && <div className="formErrors">{errors.nic}</div>}
                    </div> */}

                    {/* <div className="uk-width-1-2@m uk-margin-top">
                      <label>Password *</label>
                      <input
                        className="uk-input"
                        type="password"
                        name="password"
                        placeholder="Create a strong password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      {errors.password && <div className="formErrors">{errors.password}</div>}
                      <div className="uk-text-meta uk-margin-small-top">
                        Password must be at least 14 characters long and include uppercase, lowercase, numbers, and special characters.
                      </div>
                    </div>

                    <div className="uk-width-1-2@m uk-margin-top">
                      <label>Confirm Password *</label>
                      <input
                        className="uk-input"
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm your password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                      />
                      {errors.confirmPassword && <div className="formErrors">{errors.confirmPassword}</div>}
                    </div> */}

                    <div className="uk-width-1-1@m uk-margin-large-top ">
                      <div className="formActionBtn uk-text-right">
                        <button 
                          type="submit" 
                          className="pinkBtn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <div uk-spinner="" className="loader">
                              Creating Account...
                            </div>
                          ) : (
                            'Sign Up'
                          )}
                        </button>
                      </div>
                      {/* <div className="uk-text-center uk-margin-top">
                        Already have an account? <Link to="/login">Sign in</Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;